var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFinance = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#232323",
  d: "m5 16.5-3 2.94V11h3m5 3.66-1.57-1.34L7 14.64V7h3m5 6-3 3V3h3m2.81 9.81L16 11h5v5l-1.79-1.79L12 21.36l-3.47-3.02L4.75 22H2l6.47-6.34L12 18.64"
})));
export default SvgFinance;